export const get_domain_linking_data = "host/get/custom/dnsrecords/v2";
